import Avatar from './avatar-img';

export default Avatar;
